export default __webpack_public_path__ + "static/media/main-logo--dark.9cbfac5b.svg";